var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37745 10.7671C5.16128 10.7671 4.12766 10.3409 3.2766 9.48858C2.42553 8.63622 2 7.60122 2 6.38356C2 5.16591 2.42553 4.1309 3.2766 3.27854C4.12766 2.42618 5.16109 2 6.3769 2C7.59271 2 8.62614 2.42618 9.4772 3.27854C10.3283 4.1309 10.7538 5.16609 10.7538 6.38411C10.7538 6.87592 10.6778 7.33973 10.5258 7.77552C10.3739 8.21132 10.1641 8.61187 9.89666 8.97717L13.7994 12.8858C13.9331 13.0198 14 13.172 14 13.3425C14 13.5129 13.9331 13.6651 13.7994 13.7991C13.6657 13.933 13.5106 14 13.3343 14C13.1581 14 13.003 13.933 12.8693 13.7991L8.96657 9.90868C8.60182 10.1766 8.20188 10.3866 7.76675 10.5388C7.33161 10.691 6.86851 10.7671 6.37745 10.7671ZM6.3769 9.45205C7.22796 9.45205 7.95137 9.15373 8.54711 8.55708C9.14286 7.96043 9.44073 7.23592 9.44073 6.38356C9.44073 5.5312 9.14286 4.8067 8.54711 4.21005C7.95137 3.61339 7.22796 3.31507 6.3769 3.31507C5.52584 3.31507 4.80243 3.61339 4.20669 4.21005C3.61094 4.8067 3.31307 5.5312 3.31307 6.38356C3.31307 7.23592 3.61094 7.96043 4.20669 8.55708C4.80243 9.15373 5.52584 9.45205 6.3769 9.45205Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.76995cc454b3cf349f6a5b0d712ec0be.svg";
export { ForwardRef as ReactComponent };